import { Group, Menu, UnstyledButton } from '@mantine/core';
import IconChevronDown from '@tabler/icons-react/dist/esm/icons/IconChevronDown.mjs';
import { useEffect, useState } from 'react';

import { UsersAPI } from '@/entities/user/user';
import { EnFlagSvg, RuFlagSvg } from '@/shared/ui/icons';
import { useIsAuth } from '@/entities/user/session';
import { commonApi } from '@/shared/api/common-api';
import i18n from '@/shared/config/i18n';
import { useMutation, useQuery } from '@tanstack/react-query';
import classes from './language-selector.module.css';

import dayjs from 'dayjs';
export const CountryIcon = ({ lang, style }) => {
  switch (lang) {
    case 'ru':
      return <RuFlagSvg style={style} />;
    case 'en':
      return <EnFlagSvg style={style} />;
    default:
      return <></>;
  }
};
const data = [
  {
    key: 'en',
    label: 'English',
  },
  {
    key: 'ru',
    label: 'Русский',
  },
];

export const LanguageSelector = () => {
  const [opened, setOpened] = useState(false);

  const currentLanguage = i18n.language;
  const isAuth = useIsAuth();

  useEffect(() => {
    dayjs.locale(currentLanguage);
  }, [currentLanguage]);
  const { data: availableLanguages = [] } = useQuery({
    queryKey: ['available-languages'],
    queryFn: () => UsersAPI.getLanguages().then((res) => res.data ?? []),

    cacheTime: Infinity,
  });
  const { mutate } = useMutation({
    mutationKey: ['change-language'],
    mutationFn: (language: string) =>
      UsersAPI.changeLanguage(language).then((res) => res.data),
  });
  const changeLanguage = async (language: string) => {
    i18n.changeLanguage(language);
    commonApi.setUserLanguage({ language: language });

    if (isAuth) {
      mutate(language);
    }
  };

  const items = data
    .filter((x) => availableLanguages.includes(x.key))
    .map((item) => (
      <Menu.Item
        disabled={item.key === currentLanguage}
        leftSection={
          <CountryIcon
            lang={item.key}
            style={{
              width: '14px',
              height: '14px',
            }}
          />
        }
        onClick={() => changeLanguage(item.key)}
        key={item.label}
      >
        {item.label}
      </Menu.Item>
    ));

  return (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius='md'
      width='target'
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton
          className={classes.control}
          data-expanded={opened || undefined}
        >
          <Group gap='xs'>
            <CountryIcon
              lang={currentLanguage}
              style={{
                width: '14px',
                height: '14px',
              }}
            />
            <span className={classes.label}>
              {data?.find((x) => x.key === currentLanguage)?.label}
            </span>
          </Group>
          <IconChevronDown size='1rem' className={classes.icon} stroke={1.5} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>{items}</Menu.Dropdown>
    </Menu>
  );
};